import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import axios from "axios";
import { DynamicHeader } from "./components/DynamicHeader";
import { Footer } from "./components/Footer";
import { HomeAppleStyle as Home } from "./pages/HomeAppleStyle";
import { LaptopPurchase } from "./pages/LaptopPurchase";
import { BulkRemarketing } from "./pages/BulkRemarketing";
import { DataSecurity } from "./pages/DataSecurity";
import { Process } from "./pages/Process";
import { About } from "./pages/About";
import { RequestQuote } from "./pages/RequestQuote";
import { Impressum } from "./pages/Impressum";
import { Datenschutz } from "./pages/Datenschutz";
import { AdminDevices } from "./pages/AdminDevicesAuth";
import { AdminLeads } from "./pages/AdminLeads";

// B2B Pages
import { B2BLaptopAnkauf } from "./pages/B2BLaptopAnkauf";
import { B2BRemarketing } from "./pages/B2BRemarketing";
import { B2BDataSecurity } from "./pages/B2BDataSecurity";
import { B2BAblauf } from "./pages/B2BAblauf";

// C2B Pages
import { C2BLaptopVerkaufen } from "./pages/C2BLaptopVerkaufen";
import { C2BSmartphoneVerkaufen } from "./pages/C2BSmartphoneVerkaufen";
import { C2BSoFunktionierts } from "./pages/C2BSoFunktionierts";
import { C2BVorteile } from "./pages/C2BVorteile";
import { C2BFAQ } from "./pages/C2BFAQ";
import { C2BGeraetAnbieten } from "./pages/C2BGeraetAnbieten";

import { Toaster } from "./components/ui/sonner";
import { CookieBanner } from "./components/CookieBanner";
import { ModeProvider, useMode } from "./context/ModeContext";
import { ScrollToTop } from "./components/ScrollToTop";

function AppContent() {
  const { mode } = useMode();

  return (
    <HelmetProvider>
      <Helmet>
        <title>wirkaufendeinLaptop.de - B2B Laptop-Ankauf | Firmenlaptops verkaufen</title>
        <meta name="description" content="B2B-Ankauf von gebrauchten Firmenlaptops in größeren Mengen mit zertifizierter DSGVO-konformer Datenlöschung. Professioneller Service für Unternehmen." />
      </Helmet>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <DynamicHeader mode={mode} />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              
              {/* Old Routes (legacy) */}
              <Route path="/laptop-purchase" element={<LaptopPurchase />} />
              <Route path="/bulk-remarketing" element={<BulkRemarketing />} />
              <Route path="/data-security" element={<DataSecurity />} />
              <Route path="/process" element={<Process />} />
              <Route path="/about" element={<About />} />
              <Route path="/request-quote" element={<RequestQuote />} />
              
              {/* B2B Routes */}
              <Route path="/b2b/laptop-ankauf" element={<B2BLaptopAnkauf />} />
              <Route path="/b2b/remarketing" element={<B2BRemarketing />} />
              <Route path="/b2b/datensicherheit" element={<B2BDataSecurity />} />
              <Route path="/b2b/ablauf" element={<B2BAblauf />} />
              
              {/* C2B Routes */}
              <Route path="/c2b/laptop-verkaufen" element={<C2BLaptopVerkaufen />} />
              <Route path="/c2b/smartphone-verkaufen" element={<C2BSmartphoneVerkaufen />} />
              <Route path="/c2b/so-funktionierts" element={<C2BSoFunktionierts />} />
              <Route path="/c2b/vorteile" element={<C2BVorteile />} />
              <Route path="/c2b/faq" element={<C2BFAQ />} />
              <Route path="/c2b/geraet-anbieten" element={<C2BGeraetAnbieten />} />
              
              {/* Legal & Admin */}
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/admin/devices" element={<AdminDevices />} />
              <Route path="/admin/leads" element={<AdminLeads />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" />
          <CookieBanner />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

function App() {
  return (
    <ModeProvider>
      <AppContent />
    </ModeProvider>
  );
}

export default App;